<script>
export default {
  name: 'goods-btn',
  /**
     * 按钮状态
     *  0 未登录
     *  1 申请采购  区域经销
     *  2 有货 可以购买
     *  3 已售完
     *  4 无商品库存  我要预订
     *  5 即将开抢
     *  6 预售： 支付定金
     *  7 预售： 预售库存为0 不可点击
     *  8 预售： 提醒我 （活动未开始）
     */
  props: {
    btnType: {
      type: Number,
      default: 0
    }
  },
  methods: {
    openCart () {
      this.$emit('openCart')
    },
    fn () {
      return false
    },
    openPreRemind () {
      this.$emit('openPreRemind')
    }
  },
  render () {
    const { btnType, $style } = this
    switch (btnType) {
      case 0:
        return <div class={`${$style['btn']} ${$style['active']}`} vOn:click_stop={this.openCart}>立即抢购</div>
      case 1:
        return <div class={`${$style['btn']} ${$style['plain']}`} vOn:click_stop={this.openCart}>申请采购</div>
      case 2:
        return <div class={`${$style['btn']} ${$style['active']}`} vOn:click_stop={this.openCart}>立即抢购</div>
      case 3:
        return <div class={`${$style['btn']} ${$style['disabled']}`} vOn:click_stop={this.fn}>立即抢购</div>
      case 4:
        return <div class={`${$style['btn']} ${$style['plain']}`} vOn:click_stop={this.openCart}>我要预订</div>
      case 5:
        return <div class={`${$style['btn']} ${$style['disabled']}`} vOn:click_stop={this.fn}>即将开抢</div>
      case 6:
        return <div class={`${$style['btn']} ${$style['active']}`} vOn:click_stop={this.openCart}>支付定金</div>
      case 7:
        return <div class={`${$style['btn']} ${$style['disabled']}`} vOn:click_stop={this.fn}>支付定金</div>
      case 8:
        return <div class={`${$style['btn']} ${$style['plain']}`} vOn:click_stop={this.openPreRemind}>提醒我</div>
      default:
        return <div class={`${$style['btn']} ${$style['active']}`} vOn:click_stop={this.openCart}>立即抢购</div>
    }
  }
}
</script>
<style module lang="scss">
  .btn{
    width: 65px;
    height: 24px;
    border-radius: 12px;
    color: #ffffff;
  @include center();
    background:rgba(181,181,181,1);
  }
  .active{
    background: var(--APP_theme_color);
    box-shadow: 0px 1px 5px 0px var(--APP_theme_color_colorOpacity3);
  }
  .plain{
    border: 1px solid var(--APP_theme_color);
    background: var(--APP_theme_color_colorOpacity1);
    color: var(--APP_theme_color);
  }
  .disabled{
    color: #ffffff;
    background: #B5B5B5;
    box-shadow:0px 1px 5px 0px rgba(161,160,160,0.7);
  }

</style>
